__turbopack_context__.v({
  "helpText": "Input-module__Xvvq2G__helpText",
  "select": "Input-module__Xvvq2G__select",
  "selectError": "Input-module__Xvvq2G__selectError",
  "selectWrapper": "Input-module__Xvvq2G__selectWrapper",
});
